module.exports = __webpack_public_path__ + "static/media/599.7554(10).02141f96.pdf";